import request from './request.js';


export async function page (params = {
}) {
    return await request('/underreportingInspection/page', 'get', params)
}

export async function loadTask (params = {
}) {
    return await request('/batch/loadUnderreportingInspectionTask', 'post', params)
}